
import { CustomClaims } from "@/common-datatypes";
import Common from '@/mixins/common';
import { ModalConfirmProps, NoticeProps } from "@/scripts/datatypes";
import { auth, functions } from "@/scripts/firebase";
import { httpsCallable } from "firebase/functions";
import ModalConfirm from "@/components/ModalConfirm.vue"
import { Component, Mixins } from "vue-property-decorator";

@Component({
  components: {
    ModalConfirm
  }
})

export default class DeleteAccount extends Mixins(Common) {
  isLoading = false
  notice = {} as NoticeProps
  modalConfirmProps: ModalConfirmProps = {
    title: 'deleteAccount.deleteAccount',
    message: 'deleteAccount.confirm',
    isLoading: false
  }
  showModal = false

  get isDisabled(){
    const schools = this.$store.getters.schools as CustomClaims['schools']
    if(schools && Object.keys(schools).length > 0){
      const schoolIds = Object.keys(schools)
      return schoolIds.some((schoolId) => {
        if(schools[schoolId].roles.includes('owner')){
          return true
        }
        return false
      })
    }
    return false
  }

  async created(){
    console.trace('created');
  }
 
 async mounted(){
  console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

  async deleteAccount(confirm: boolean){
    if(! confirm){
      this.showModal = false
      return
    }

    this.$store.commit("setLoading",true)
    this.modalConfirmProps.isLoading = true
    
    try{
      const deleteAccount = httpsCallable(functions,'deleteAccount')
      await deleteAccount()
      this.$store.commit("setLoading",false)
      this.modalConfirmProps.isLoading = false
      this.showModal = false
       auth.signOut()
       this.$router.push({path: '/',query: { account: 'deleted'}})
    }catch(error){
      const errorCode = this.$getErrorCode(error)
      // eslint-disable-next-line
      const errorMessage = this.$t(this.$getErrorMessageKey(errorCode)) as string
      this.notice = {
        message: this.$t('deleteAccount.error'),
        isShow: true,
        type: {'is-danger': true}
      }
    }finally{
      this.$store.commit("setLoading",false)
      this.modalConfirmProps.isLoading = false
      this.showModal = false
    }
  }
}
